import { motion, useReducedMotion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import configuredLinks from '../config/links';

const { FiArrowUpRight, FiCheck } = FiIcons;

const benefits = [
  'Every live AIPosse member event',
  'AI Mastermind replays and key takeaways',
  'Private community and meaningful connections',
  'Guest founder and AI operator conversations',
  'Create Your Own Gravity aftershow',
  'New rooms and voices added continuously'
];

const paths = [
  {
    title: 'Experience',
    subtitle: 'Five-Day AIPosse Support Pass',
    price: 'Five days beginning at $5',
    description:
      'Choose any one-time amount beginning at $5. Includes five days of AIPosse access, does not renew automatically and lets you experience the room before choosing an ongoing membership.'
  },
  {
    title: 'Join',
    subtitle: 'Monthly AIPosse Membership',
    price: 'Complete access for $9/month',
    badge: 'Most Popular',
    description:
      'Includes every AIPosse member event with no additional AIPosse event fees. Renews monthly until canceled.'
  },
  {
    title: 'Build',
    subtitle: 'Annual AIPosse Patron Membership',
    price: 'Annual patron access for $578.50',
    description:
      'Includes complete annual access and an optional Create Your Own Gravity podcast conversation. You may decline the conversation and use the full amount to support the work. Renews annually until canceled.'
  }
];

function MembershipPanel() {
  const reduceMotion = useReducedMotion();

  return (
    <motion.section
      className="membership-panel"
      initial={reduceMotion ? false : { opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7 }}
      aria-labelledby="gateway-title"
    >
      <p className="eyebrow">
        <span />
        You Chose an AIPosse Member Event
      </p>

      <h1 id="gateway-title">
        One Membership.
        <span>Every Event.</span>
      </h1>

      <p className="supporting-copy">
        AIPosse is where builders, founders, consultants and AI operators meet
        the people and ideas shaping what comes next.
      </p>

      <p className="value-statement">
        The $9 monthly membership includes every AIPosse member event, AI
        Mastermind replays and takeaways, private community connections, guest
        conversations and the Create Your Own Gravity aftershow.
      </p>

      <p className="emotional-statement">
        $9 won’t make us rich. It keeps the right people in the room—and helps
        us keep making great voices heard.
      </p>

      <section className="offer-preview" aria-labelledby="offer-preview-title">
        <h2 id="offer-preview-title">Choose Your Way Into the Room</h2>
        <div className="offer-paths">
          {paths.map((path) => (
            <article className="offer-path" key={path.title}>
              {path.badge && <span className="path-badge">{path.badge}</span>}
              <h3>{path.title}</h3>
              <p>{path.subtitle}</p>
              <strong>{path.price}</strong>
              <span>{path.description}</span>
            </article>
          ))}
        </div>
        <p className="offer-clarification">
          You will choose your access or support option securely on the next
          page.
        </p>
      </section>

      <div className="membership-card">
        <div className="membership-card-heading">
          <div>
            <span>Everything Inside the Territory</span>
            <strong>Member signal: active</strong>
          </div>
          <p>
            <b>$9</b>
            <span>/ month</span>
          </p>
        </div>

        <ul>
          {benefits.map((benefit) => (
            <li key={benefit}>
              <SafeIcon icon={FiCheck} />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>

        <a
          className="primary-cta"
          href={configuredLinks.membershipCheckout}
          target="_top"
        >
          Join AIPosse Now
          <SafeIcon icon={FiArrowUpRight} />
        </a>
        <a
          className="membership-details-link"
          href={configuredLinks.membershipDetails}
          target="_top"
        >
          See Everything Included
        </a>
        <p className="cta-clarification">
          Choose a five-day pass, monthly membership or annual patron membership
          securely on the next page.
        </p>
      </div>
    </motion.section>
  );
}

export default MembershipPanel;